module.exports = __webpack_public_path__ + "static/media/card.e3291eb8.png";